(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('CommunityNewsController', CommunityNewsController);
      
  CommunityNewsController.$inject = [
    '$log', 
    '$scope',
    'shell',
    'myPollsService'
  ];
    
  function CommunityNewsController(
      $log, 
      $scope,
      shell,
      myPollsService
  ) {
    
    $log = $log.getInstance('CommunityNewsController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.announcements = [];
    vm.shell = shell;

    activate();
    
    function activate() {
      shell.setTitle('Community News');
      myPollsService.getAnnouncements()
        .then(function(announcements) {
          if (!announcements)
            return;
          vm.announcements = announcements;
          return myPollsService.updateUser({
            lastReadAnnouncement: announcements[0]._id 
          });
        })
        .then(function() {
          $scope.$emit('communityNews.announcementsRead');
        });
    }

  }
  
})();